import styled, { css } from "styled-components";
import { rgba } from "polished";
import { color, onHover } from "@m/alchemy-theme";
const hoverStyles = (props) => {
    if (props.shouldHighlightOnHover) {
        return onHover(css `
        background-color: ${rgba(color("hint")(props), 0.5)};
      `, { includeFocusWithin: true });
    }
    return "";
};
export const TableRow = styled.tr `
  background-color: ${({ isHighlighted }) => (isHighlighted ? color("hint") : "transparent")};
  color: ${({ isHighlighted }) => (isHighlighted ? color("typeBody") : "inherit")};
  ${hoverStyles};

  [data-whatinput="keyboard"] &:focus,
  [data-whatinput="keyboard"] &.has-proxy-focus {
    outline: none;
    background-color: ${color("hint")};
  }

  > td,
  > th {
    border-bottom: 1px solid
      ${({ isHeader }) => isHeader ? color("line", { palette: "structural" }) : color("hint", { palette: "structural" })};
  }
`;
